import React from 'react'
import styled from 'styled-components'
import bg from '@/images/bg.jpg'
import texture from '@/images/texture.png'

const BgComponent = styled.div`
  background-image: url(${bg});
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  filter: blur(10px);
  z-index: -1;
`
const TextureBg = styled.div`
  background-image: url(${texture});
  background-size: 200px;
  z-index: 10;
  opacity: 0.1;
  pointer-events: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

const Bg = () => {
  return (
    <>
      <BgComponent />
      <TextureBg />
    </>
  )
}

export default Bg
